export default __webpack_public_path__ + "static/media/17.65399d56.jpg";